import { CategoryModel } from 'api/dto/Category.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'categories';

export namespace CategoriesState {
  export type Domain = {
    categoriesResource: Resource<Readonly<CategoryModel[]>>;
  };

  export const INITIAL_DOMAIN: Domain = {
    categoriesResource: Resource.createPendingResource<Readonly<CategoryModel[]>>(),
  };
}
